// Finding a customer by what was typed: their name, address or postcode, spaces and case ignored. Book a visit's list
// and More > Invoices' New invoice share it (docs/plans/invoice-maker/PLAN.md 3), so a customer found in one is found in
// the other.
export function findCustomers<T extends { name: string; address?: string | null; postcode?: string | null }>(list: T[], typed: string): T[] {
  const q = typed.trim().toLowerCase().replace(/\s/g, '')
  return list.filter((c) => [c.name, c.address, c.postcode].some((v) => (v ?? '').toLowerCase().replace(/\s/g, '').includes(q)))
}
